
const initioalState = {
    item:[
        {id: 1, url: "", text: "test"}
    ]
}
function imageReducer(state=initioalState, action) {
    switch (action.type){
        case "FETCH_IMAGE":
            return state
        case "ADD_IMAGE":
            return {...state, item: state.item.concat(action.payload)}

        default: 
            return state;
    }
}

export default imageReducer;